import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "/node_modules/sal.js/dist/sal.css";

import { useEffect, useRef, useState } from "react";
import { useOnClickOutside } from "../utils/hooks";
import { Popover } from "antd";

import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import AppLogo from "~/components/app/AppLogo";
import { getSliders } from "~/redux/actions/app";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isMobile } from "react-device-detect";

import sal from "sal.js";

const Page = (props) => {
  const ref = useRef(null);
  const [imagesVisible, setImagesVisible] = useState(false);

  const menu = (
    <>
      <div
        onClick={() =>
          window.open("https://github.com/eleduck/English4Developers")
        }
      >
        Github
      </div>
      <div onClick={() => window.open("https://eleduck.com/")}>社区</div>
      <div onClick={() => window.open("https://eleduck.com/posts/6yGflz")}>
        加入&合作
      </div>
    </>
  );
  const content = <div className="my-popup">{menu}</div>;

  const showImages = (index) => {
    setImagesVisible(true);
    const dom = document.getElementById("swiper");
    const swiper = dom.swiper;
    swiper && swiper.slideTo(index);
  };

  const handleClickOutSide = () => {
    setImagesVisible(false);
  };

  useOnClickOutside(ref, handleClickOutSide);
  useEffect(() => {
    sal();
    props.getSliders();
  }, []);
  return (
    <div className="english">
      <div className="section-1">
        <div className="nav" data-sal="slide-up">
          <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/logo-text.png" />
          <div className="nav-menu">{menu}</div>
          <Popover placement="bottom" content={content} trigger="click">
            <div className="nav-menu-icon">
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/menu.png" />
            </div>
          </Popover>
        </div>
        <div className="content-wrapper">
          <div className="item">
            <div className="text-1" data-sal="slide-up">
              英语练习俱乐部
            </div>
            <div className="text-4">English Practicing Club</div>
            <div className="line" data-sal="slide-up"></div>
            <div className="text-2" data-sal="slide-up">
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/text-left.png" />
            </div>
            <div className="items-wrapper">
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>英文简历面试经验</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>英文读写练习纠错</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>文字群聊&纠错优化</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>语音群聊&发音指导</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>线上口语圆桌练习</span>
              </div>
            </div>
            <div className="member-wrapper" data-sal="slide-up">
              {Array(25)
                .fill()
                .map((value, index) => (
                  <img
                    src={`https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/${
                      index + 1
                    }.png`}
                  />
                ))}
              <span className="omit">...</span>
            </div>
            <div className="text-3" data-sal="slide-up">
              目前成员206人
            </div>
            <a
              className="common-btn"
              data-sal="slide-up"
              href="https://eleduck.com/posts/pqfjZ1"
            >
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/button-left.png" />
            </a>
          </div>
          <div className="item">
            <div className="text-1" data-sal="slide-up">
              英语求职训练营
            </div>
            <div className="text-4">English Job Hunting Bootcamp</div>
            <div className="line" data-sal="slide-up"></div>
            <div className="text-2" data-sal="slide-up">
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/text-right.png" />
            </div>
            <div className="items-wrapper">
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>英语简历</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>求职信</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>行为面试</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>技术面试</span>
              </div>
              <div data-sal="slide-up">
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/mark.png" />
                <span>面试模拟</span>
              </div>
            </div>
            <div className="member-wrapper" data-sal="slide-up">
              {Array(25)
                .fill()
                .map((value, index) => (
                  <img
                    src={`https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/${
                      index + 26
                    }.png`}
                  />
                ))}
              <span className="omit">...</span>
            </div>
            <div className="text-3" data-sal="slide-up">
              已举办10期，结营学员146人
            </div>
            <a
              className="common-btn"
              data-sal="slide-up"
              href="https://eleduck.com/posts/R3f1bm"
            >
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/button-right.png" />
            </a>
          </div>
        </div>
        <div className="white-block"></div>
      </div>
      <div className="section-2">
        <img
          src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/down.png"
          data-sal="slide-up"
        />
        <div className="table-wrapper" data-sal="slide-up">
          <div data-sal="slide-up">
            <div></div>
            <div>
              <div>训练目的</div>
              <div>PURPOSE</div>
            </div>
            <div>
              <div>周期</div>
              <div>CYCLE</div>
            </div>
            <div className="big">
              <div>内容</div>
              <div>CONTENT</div>
            </div>
            <div>
              <div>价格</div>
              <div>PRICING</div>
            </div>
            <div>
              <div>人群</div>
              <div>TARGET</div>
            </div>
            <div>
              <div>加入方式</div>
              <div>WAY TO JOIN</div>
            </div>
          </div>
          <div data-sal="slide-up">
            <div>
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/job.png" />
            </div>
            <div>面向求职</div>
            <div>1个月</div>
            <div className="big">简历/求职信/模拟面试</div>
            <div>2930¥/人/期</div>
            <div>开发/运维/测试</div>
            <div>提前预约</div>
          </div>
          <div data-sal="slide-up">
            <div>
              <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/club.png" />
            </div>
            <div>综合练习</div>
            <div>1年</div>
            <div className="big">工作英语，听说读写</div>
            <div>850¥/人/年</div>
            <div>开发/设计/产品</div>
            <div>即时加入</div>
          </div>
        </div>
        <div className="phone-table-wrapper" data-sal="slide-up">
          <div className="mid">
            <div>训练目的</div>
            <div>周期</div>
            <div>内容</div>
            <div>价格</div>
            <div>人群</div>
            <div>加入方式</div>
          </div>
          <div className="items-wrapper">
            <div className="item">
              <div>
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/club.png" />
              </div>
              <div>综合练习</div>
              <div>1年</div>
              <div>工作英语，听说读写</div>
              <div>850¥/人/年</div>
              <div>开发/设计/产品</div>
              <div>即时加入</div>
            </div>
            <div className="item">
              <div>
                <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/job.png" />
              </div>
              <div>面向求职</div>
              <div>1个月</div>
              <div>简历/求职信/模拟面试</div>
              <div>2930¥/人/期</div>
              <div>开发/运维/测试</div>
              <div>提前预约</div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-3" data-sal="slide-up">
        <div className="text-1">
          <img src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/feedback.png" />
        </div>
        <div className="text-2">What People Said</div>
        <div className="my-swiper">
          <img
            src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/cover.png"
            className="cover-img-l"
            style={{ height: "16vw", filter: "grayscale(0.5) blur(40px)" }}
          />
          <img
            src="https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/cover.png"
            className="cover-img-r"
            style={{ height: "16vw", filter: "grayscale(0.5) blur(40px)" }}
          />
          <Swiper
            slidesPerView={8}
            spaceBetween={30}
            modules={[Autoplay, Pagination, Navigation]}
            loop={props.sliders && props.sliders.length > 6 ? true : false}
            zoom={true}
            centerInsufficientSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            className="carousels mt-20 carousels-web"
            style={{ transform: "scale(1.3)" }}
          >
            {props.sliders &&
              props.sliders.map((slider, index) => (
                <SwiperSlide onClick={() => showImages(index)}>
                  <div className="img-wrapper">
                    <img src={slider.image_url} />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            modules={[Autoplay, Pagination, Navigation]}
            loop={props.sliders && props.sliders.length > 2 ? true : false}
            zoom={true}
            centerInsufficientSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            className="carousels mt-20 carousels-phone"
            style={{ transform: "scale(1.3)" }}
          >
            {props.sliders &&
              props.sliders.map((slider, index) => (
                <SwiperSlide onClick={() => showImages(index)}>
                  <div className="img-wrapper">
                    <img src={slider.image_url} />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
        <div
          style={{ display: `${imagesVisible ? "inline-block" : "none"}` }}
          className="image-view"
        >
          <div className="wrapper" ref={ref}>
            <Swiper
              id="swiper"
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
            >
              {props.sliders &&
                props.sliders.map((slider) => (
                  <SwiperSlide>
                    <div
                      className={
                        isMobile
                          ? "mobile-image-item-wrapper image-item-wrapper"
                          : "web-image-item-wrapper image-item-wrapper"
                      }
                    >
                      <img src={slider.image_url} />
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
            <div className="close" onClick={() => setImagesVisible(false)}>
              <div>&times;</div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-4">
        <div className="left">
          <div className="logo">
            <AppLogo />
          </div>
          <div className="slogan">
            作为电鸭社区官方出品的培训服务，我们希望能成为你远程路上，真正助你成长的伙伴。
          </div>
        </div>
        <div className="v-line"></div>
        <div className="h-line"></div>
        <div className="right">
          <div className="copy-right">
            <span>© 2019 www.eleduck.com</span>
            <span>版权所有电鸭 京ICP备133434584号</span>
          </div>
        </div>
      </div>
      <style jsx>{`
        .section-1 {
          background-image: url("https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/bg.png");
          background-size: cover;
        }
        .section-2 .table-wrapper {
          background-image: url("https://duckfiles.oss-cn-qingdao.aliyuncs.com/images/english/table-bg.png");
          background-size: cover;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sliders: state.app.sliders,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSliders,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Page);
